document.addEventListener("DOMContentLoaded", () => {
	// Handle dvd pricing change for each capture product
	var dvdPricingInput = $("[data-original-dvd-price]");
	var productType = dvdPricingInput.attr("data-type");
	var dvdMessage = "";
	var dvdThemeMusicOutput = $(".product-outputs .third-output-wrapper");
	if (productType == "digital-media" || productType == "digital") {
		dvdMessage = `per copy`;
	} else if (productType == "film") {
		dvdMessage = `per copy`;
	} else if (productType == "photo") {
		dvdMessage = `per copy`;
	} else if (productType == "video") {
		dvdMessage = `per copy`;
	} else if (productType == "album") {
		dvdMessage = `per copy`;
	}
	dvdPricingInput.find("small").text(dvdMessage);

	function formatDvd(value = 0) {
		if (
			productType == "video" ||
			productType == "digital-media" ||
			productType == "digital" ||
			productType == "album" ||
			productType == "photo"
		) {
			var dvdValue = Math.max(1, value);
			var newDvdPrice =
				dvdPricingInput.attr("data-original-dvd-price") * dvdValue;
			var newDvdPriceFormatted = formatMoney(newDvdPrice);
			dvdPricingInput.attr("data-dvd-price", newDvdPrice);
			dvdPricingInput.find(".final-price").text(newDvdPriceFormatted);
			if (productType == "video") {
				dvdPricingInput
					.find("small")
					.text(`for ${value || 1} copy`);
			}
			if (productType == "digital-media" || productType == "digital") {
				dvdPricingInput
					.find("small")
					.text(
						`for ${
							value || 1
						} copy`
					);
			}
			if (productType == "album" || productType == "photo") {
				dvdPricingInput
					.find("small")
					.text(` per copy`);
			}
		}
	}

	if (productType == "video") {
		var quantityPrefix = "video";
	}
	if (productType == "digital-media" || productType == "digital") {
		var quantityPrefix = "digital";
	}

	var quantityInput = $(`input[name="${quantityPrefix}-quantity"]`);
	var value = Number($(quantityInput).val());
	quantityInput.change(function (e) {
		var value = Number($(this).val());
		if (value > CONSTANTS.DIGITAL.THRESHOLD) {
			$(this).val(CONSTANTS.DIGITAL.THRESHOLD);
			value = CONSTANTS.DIGITAL.THRESHOLD;
		}
		formatDvd(value);
	});

	if (productType == "album" || productType == "photo") {
		var quantityPrefix = productType == "photo" ? "photo" : "album";
		var multiQuantityInputs = $(`input[name="${quantityPrefix}-quantity"]`);
		var value = multiQuantityInputs.filter(function () {
			var value = Number($(this).val());
			return value;
		}).length;
		multiQuantityInputs.change(function (e) {
			var value = multiQuantityInputs.filter(function () {
				var value = Number($(this).val());
				return value;
			}).length;
			formatDvd(value);
		});
	}

	// Hide dvd theme / music output
	if (dvdThemeMusicOutput) {
		// if video, dvd music should be hidden
		if (productType == "video") {
			dvdThemeMusicOutput.find(".music-options-wrapper").hide();
		}
	}
	formatDvd(value);
});
